import React from "react";
import { object, string } from "prop-types";

import Anchor from "../Anchor";

import "./subSectionsMenuItems.m.css";

const SubSectionsMenuItems = ({ sectionsDataForHeader = null, src }) => {
  if (!sectionsDataForHeader) return null;

  const childSections = sectionsDataForHeader.childSections;

  if (!(childSections && childSections.length)) return null;

  const headerWrapperStyleName = src !== "section" ? "header-sections" : "";

  return (
    <ul styleName={`sub-sections ${headerWrapperStyleName}`} className="sub-sections">
      {childSections.slice(0, 12).map((item, index) => {
        return (
          <li styleName="child-section" className="child-section" key={index}>
            <Anchor aria-label={item["display-name"]} href={item["section-url"]}>
              {item["display-name"]}
            </Anchor>
          </li>
        );
      })}
    </ul>
  );
};

SubSectionsMenuItems.propTypes = {
  sectionsDataForHeader: object,
  src: string,
};

export default SubSectionsMenuItems;
